<template>
  <b-modal
    v-model="showModal"
    id="modal-service-fee-upgrade"
    modal-class="modal-service-fee-upgrade"
    hide-footer
    hide-header
    centered
    no-close-on-backdrop
  >
    <!-- Close icon top-right -->
    <div class="modal-close-container">
      <feather-icon
        class="cursor-pointer icon-close"
        icon="XIcon"
        size="20"
        @click="closeModal"
      />
    </div>

    <!-- Modal Body Content -->
    <div class="modal-body-content text-center">
      <div class="image-wrapper mb-2">
        <b-img
          class="upgrade-img"
          alt="Service Fee Upgrade"
          :src="require('@/assets/images/common/ic-popup-service-fee.png')"
        />
      </div>

      <h3 class="modal-title font-weight-bolder text-center mb-1">
        {{ $t('serviceFeePopup.title') }}
      </h3>

      <p class="modal-desc text-left">
        {{ $t('serviceFeePopup.description') }}
      </p>

      <!-- Bullet points list -->
      <ul class="modal-list">
        <li class="modal-list-item">
          <span v-html="$t('serviceFeePopup.bullet1')" />
        </li>
        <li class="modal-list-item">
          <span>{{ $t('serviceFeePopup.bullet2') }}</span>
        </li>
      </ul>

      <!-- Lavender Note Box -->
      <div class="note-box">
        <strong class="note-prefix font-weight-600">{{ $t('serviceFeePopup.notePrefix') }}</strong>
        <span class="note-text">{{ $t('serviceFeePopup.noteText') }}</span>
      </div>

      <!-- Support team line -->
      <p class="support-text mb-2">
        {{ $t('serviceFeePopup.questionPrefix') }}
        <a
          href="#"
          class="support-link font-weight-600 underline"
          @click.prevent="handleGoToSupport"
        >
          {{ $t('serviceFeePopup.supportLinkText') }}
        </a>
        {{ $t('serviceFeePopup.questionSuffix') }}
      </p>

      <!-- Close Button using project standard button -->
      <div class="d-flex justify-content-center">
        <btn-loading
          variant-convert="btn-submit"
          pill
          class="btn-close-upgrade"
          @click="closeModal"
        >
          {{ $t('common.btnClose') || 'Close' }}
        </btn-loading>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal,
  BImg,
} from 'bootstrap-vue'
import BtnLoading from '@/layouts/components/BtnLoading.vue'
import envMixin from '@/mixins/envMixin'

export default {
  name: 'ServiceFeeUpgradeModal',
  components: {
    BModal,
    BImg,
    BtnLoading,
  },
  mixins: [envMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: this.show,
    }
  },
  watch: {
    show: {
      handler(val) {
        this.showModal = val
      },
      immediate: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit('close-modal')
    },
    handleGoToSupport() {
      window.open('https://wa.me/84345741502', '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-close-container {
  display: flex;
  justify-content: flex-end;

  .icon-close {
    color: #64748b;
    transition: color 0.2s ease;

    &:hover {
      color: #1e293b;
    }
  }
}

.upgrade-img {
  width: 100%;
  max-width: 172px;
  height: auto;
}

.modal-title {
  font-size: 21px;
  font-weight: 600 !important;
  color: #1e293b;
  line-height: 28px;
}

.modal-desc {
  font-size: 14.5px;
  color: #475569;
  line-height: 22px;
  text-align: left;
  margin-bottom: 8px !important;
}

.modal-list {
  list-style-type: none;
  padding-left: 0;
  margin: 0;

  .modal-list-item {
    position: relative;
    padding-left: 18px;
    font-size: 14px;
    color: #475569;
    line-height: 20px;
    text-align: left;

    &::before {
      content: "•";
      position: absolute;
      left: 4px;
      color: #475569;
      font-size: 18px;
      top: -1px;
    }

    strong {
      font-weight: 700 !important;
      color: #1e293b !important;
    }
  }
}

.note-box {
  background-color: #eef2ff;
  border-radius: 12px;
  padding: 14px 18px;
  margin: 8px 0;
  font-size: 13px;
  line-height: 18px;
  color: #3b4256;
  text-align: left;

  .note-prefix {
    color: #3b4256;
  }
}

.support-text {
  font-size: 13px;
  color: #64748b;
  line-height: 18px;
  text-align: left;

  .support-link {
    color: #3b82f6;
    text-decoration: underline;

    &:hover {
      color: #1d4ed8;
    }
  }
}

.btn-close-upgrade {
  height: 40px !important;
  padding: 0 48px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}
</style>

<style lang="scss">
/* Global styles for the modal structure to override bootstrap modal styling */
.modal-service-fee-upgrade {
  .modal-dialog {
    width: 488px !important;
    max-width: 488px !important;
    margin: 1.75rem auto;

    @media (max-width: 576px) {
      margin: 1rem;
      width: calc(100% - 2rem) !important;
      max-width: calc(100% - 2rem) !important;
    }
  }

  .modal-content {
    border-radius: 24px !important;
    border: none !important;
    padding: 24px !important;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  }

  .modal-body {
    padding: 0 !important;
  }
}
</style>
